import { useEffect, useRef } from 'react';

function usePrevious<T extends unknown>(value: T, initialValue?: T) {
    const ref = useRef<T | undefined>(initialValue);

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
}

export default usePrevious;
